import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Confirmation, State } from './types'

const initialState: State = {
  message: null,
};

export const confirmationSlice = createSlice({
  name: 'confirmation',
  initialState,
  reducers: {
    setMessage(state, action: PayloadAction<Confirmation | null>) {
      state.message = action.payload;
    },
  },
  selectors: {
    selectMessage: (state) => state.message,
  },
});

export const { setMessage } = confirmationSlice.actions;
export const { selectMessage } = confirmationSlice.selectors;

